        function fooBar() {
          var leMontant = jQuery("#fsb_amount").text();
          if (jQuery("body").hasClass("fr-langify")) {
            
            if (leMontant == "") {
                jQuery("#fsb_bar").html('Félicitations ! Votre commande se qualifie pour la livraison gratuite !');
            } else {
            	jQuery("#fsb_bar").html('Que <span id="fsb_amount" style="color: rgb(255, 255, 255); font-family: Verdana; font-size: 18px;">' + leMontant + '</span><span id="fsb_symbol" style="color: rgb(255, 255, 255); font-family: Verdana; font-size: 18px;">$</span> de plus (CAD) pour la livraison gratuite !');
            }
          }
        }
        
        function optionRemove() {
          jQuery("#shopify-section-static-product option").each(function() {
              if (jQuery(this).attr("disabled") == "disabled") {
                  jQuery(this).css("display", "none");
              }
          });
        }
        
        $( document ).ready(function() {
          setTimeout(fooBar, 2500);
          setTimeout(optionRemove, 500);
          
        });
        setTimeout(fooBar, 5000);
		setTimeout(fooBar, 7500);
        function modalWait() {
         	jQuery(".modal-inner .product--outer option").each(function() {
              if (jQuery(this).attr("disabled") == "disabled") {
                  jQuery(this).css("display", "none");
              }
          }); 
        }
        
        jQuery(".productitem--action-trigger").on("click", function() {
          setTimeout(modalWait, 100);
        });